import { useEffect, useState } from "react";
import insuranceService, {
  FieldChoiceOption,
  InsuranceFieldChoicesMap,
} from "../../../services/insuranceService";

let cachePromise: Promise<InsuranceFieldChoicesMap> | null = null;
const loadChoices = (): Promise<InsuranceFieldChoicesMap> => {
  if (!cachePromise) {
    cachePromise = insuranceService.getFieldChoices().catch((err) => {
      cachePromise = null;
      throw err;
    });
  }
  return cachePromise;
};

export function useFieldChoices(
  insuranceType: string,
  fieldKey: string,
): FieldChoiceOption[] {
  const [choices, setChoices] = useState<InsuranceFieldChoicesMap | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadChoices()
      .then((data) => {
        if (!cancelled) setChoices(data);
      })
      .catch(() => {
        if (!cancelled) setChoices({});
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!choices) return [];
  return choices[insuranceType]?.[fieldKey] ?? [];
}
